import basicClassCreator from '../utils/basicClassCreator';

export default basicClassCreator('Spacer', 'mdl-layout-spacer');



// WEBPACK FOOTER //
// /Users/tleunen/dev/react-mdl/src/Layout/Spacer.js